/**
 * Tags the article's closing line — Figma 14773:1275 (desktop) / 14773:1793 (mobile) end
 * every article on a sea-green 18px line, e.g. "Hydrate smarter. Perform better.". The
 * editor emits it as a paragraph wholly wrapped in <strong>, and CSS cannot single that
 * out: :only-child ignores text nodes, so `p > strong:only-child` also matches paragraphs
 * that merely *end* on a bold phrase — 2 of the 4 candidates across this blog. Comparing
 * the paragraph's text with the bold run's is the only exact test.
 */
if (!customElements.get('article-body')) {
  customElements.define(
    'article-body',
    class ArticleBody extends HTMLElement {
      connectedCallback() {
        const closing = this.querySelector('.article-page__content')?.lastElementChild;

        if (!closing || closing.tagName !== 'P') {
          return;
        }

        const bold = closing.querySelector(':scope > strong:only-child');
        const text = closing.textContent.trim();

        // A closing line is a sentence. A single unbroken token is a stray bold URL.
        if (!bold || !text.includes(' ') || bold.textContent.trim() !== text) {
          return;
        }

        closing.classList.add('article-page__closing');
      }
    },
  );
}

/**
 * Points the article's "Back to blog" link at the listing page the reader arrived from.
 * The blog listing keeps its page in `?page=` (client-side in `section-learn-hub.js`,
 * server-side in `sections/blog.liquid`), but the link is rendered from `blog.url`, which
 * always resolves to page 1. The referrer already carries the page, so use it whenever it
 * points at the very listing the link targets.
 */
if (!customElements.get('article-back-link')) {
  customElements.define(
    'article-back-link',
    class ArticleBackLink extends HTMLElement {
      connectedCallback() {
        const link = this.querySelector('a');

        if (!link || !document.referrer) {
          return;
        }

        const referrer = new URL(document.referrer, window.location.href);
        const target = new URL(link.href, window.location.href);

        if (referrer.origin !== target.origin || referrer.pathname !== target.pathname) {
          return;
        }

        link.href = `${referrer.pathname}${referrer.search}`;
      }
    },
  );
}
